import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToElement, scrollToTopSmooth } from "../utils/scroll";

export const useSiteNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const goToPathTop = useCallback(
        (path: string) => {
            if (location.pathname === path) {
                scrollToTopSmooth();
            } else {
                navigate(path);
                setTimeout(scrollToTopSmooth, 60);
            }
        },
        [location.pathname, navigate]
    );

    const scrollToId = useCallback(
        (targetId: string) => {
            const doScroll = () => scrollToElement(targetId);

            if (location.pathname !== "/") {
                navigate("/");
                setTimeout(doScroll, 90);
            } else {
                doScroll();
            }
        },
        [location.pathname, navigate]
    );

    return { goToPathTop, scrollToId, scrollToTopSmooth, location, navigate };
};
